import React from 'react'
import { Outlet } from 'react-router-dom'

const ReportController = () => {
    return (
        <Outlet />
    )
}

export default ReportController
